module.exports = __webpack_public_path__ + "img/circle.cc6296be.svg";